 const cardGroup = {

	props: {
		groupe: Object,
		action: Function
	},

	methods: { 
		getInitial(type){
			if(type == 'wholesale') return "WS"
			if(type == 'retail') return "RT"
			return type;
		}
	}, 
	template: `
		<div>
			<div class="card pb-0 m-0">
				<div class="card-body">
					<div class="row align-items-center">
							<div class="col-auto">
								<div class="avatar avatar-md">
									<span class="avatar-title rounded bg-light-secondary" :class="'bg-'+groupe.type">{{getInitial(groupe.type)}}</span>
								</div>
							</div>
							<div class="col ms-n2">
								<h5 class="m-0">{{groupe.v}}</h5>
								<p class="small text-muted mb-0"> 
									<i class="fe fe-users me-2"></i>
									<span>{{(groupe.rows)? groupe.rows.length : 0}} users</span>
								</p>
							</div>
						<div class="col-auto ms-n2">
							<slot></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	`

}

export default cardGroup
